import { extendTheme } from "@chakra-ui/react";

const aRgb = (hex) => {
  const limpio = hex.replace("#", "");
  return [0, 2, 4].map((inicio) => parseInt(limpio.slice(inicio, inicio + 2), 16));
};

const aHex = (rgb) => `#${rgb.map((valor) => Math.round(valor).toString(16).padStart(2, "0")).join("")}`;

const mezclar = (rgb, con, cantidad) => rgb.map((valor, i) => valor + (con[i] - valor) * cantidad);

/**
 * Tonos 100-900 de Chakra a partir del color de la empresa: el 500 es el color tal cual,
 * los claros se mezclan con blanco y los oscuros con negro.
 * @param {String} hex - "#RRGGBB"
 */
export const generarPaleta = (hex) => {
  const base = aRgb(hex);
  const blanco = [255, 255, 255];
  const negro = [0, 0, 0];
  return {
    50: aHex(mezclar(base, blanco, 0.92)),
    100: aHex(mezclar(base, blanco, 0.8)),
    200: aHex(mezclar(base, blanco, 0.6)),
    300: aHex(mezclar(base, blanco, 0.4)),
    400: aHex(mezclar(base, blanco, 0.2)),
    500: aHex(base),
    600: aHex(mezclar(base, negro, 0.2)),
    700: aHex(mezclar(base, negro, 0.4)),
    800: aHex(mezclar(base, negro, 0.6)),
    900: aHex(mezclar(base, negro, 0.75)),
  };
};

const COLOR_VALIDO = /^#[0-9a-fA-F]{6}$/;

/** El tema de la app con el color de la empresa como color de marca. */
export const temaConColor = (temaBase, color) => {
  if (!COLOR_VALIDO.test(color || "")) return temaBase;
  const paleta = generarPaleta(color);
  return extendTheme(temaBase, { colors: { brand: paleta, brandScheme: paleta, brandTabs: paleta } });
};
